import styled, { createGlobalStyle, css } from 'styled-components'

export const Container = styled.div<{ vertical?: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;

  ${({ vertical }) =>
    vertical &&
    css`
      aspect-ratio: 9 / 16;
    `}
`

export const Global = createGlobalStyle`
  mux-player {
    --seek-backward-button: none;
    --seek-forward-button: none;
    --time-display: inline-flex;
    --playback-rate-selectmenu: inline-flex;
    --pip-button: inline-flex;
    --volume-range: none;

    position: absolute;
    top: 0;
    bottom: 0;
    overflow: hidden;

    @media (min-width: 470px) {
      --play-button: inline-flex;
      --volume-range: inline-flex;
    }

    @media all and (display-mode: standalone) {
      --pip-button: none;
    }

    &::part(poster) {
      --media-object-fit: cover;
    }

    &::part(center play button) {
      // Play button background hover color
      --_accent-color: rgba(9, 9, 9, 0.65);

      @include media-query(sm) {
        // Play button background
        --media-control-background: rgba(0, 0, 0, 0.4);
      }
    }

    &::part(bottom) {
      // Control bar button hover
      --media-control-hover-background: rgba(255, 255, 255, 0.15);

      // Remove little line on timerange hover
      --media-range-track-pointer-border-right: none;

      // Timerange colors
      --media-range-bar-color: white;
      --media-range-thumb-background: white;
      --media-time-range-buffered-color: rgba(255, 255, 255, 0.4);

      // Playback rate, quality, CC option styles
      --media-option-selected-background: transparent;
      --media-option-hover-background: rgba(255, 255, 255, 0.15);
      --media-option-hover-outline: none;
      --media-menu-item-checked-background: rgb(0, 0, 0);
    }

    // Control bar buttons spacing
    @include media-query(sm) {
      &::part(bottom button) {
        margin-left: 6px;
        margin-right: 6px;
      }
      &::part(bottom fullscreen button) {
        margin-right: 0;
      }
      &::part(bottom play button) {
        margin-left: 0;
      }
      &::part(bottom mute button) {
        margin-right: 0;
      }
    }

    // Timerange
    &::part(bottom time range) {
      --media-preview-thumbnail-background: none;
      --media-preview-thumbnail-border: 5px solid rgba(0, 0, 0, 0.7);
      --media-preview-time-background: rgba(0, 0, 0, 0.7);
      --media-text-color: white;
      --_primary-color: rgba(0, 0, 0, 0.7);

      @include media-query(sm) {
        padding-left: 18px;
        padding-right: 18px;
      }
    }

    // Controll bar (under timerange)
    &::part(control-bar bottom) {
      // Dropdown menu
      --_primary-color: rgba(0, 0, 0, 0.7);
      --_text-color: white;
      --_accent-color: white;
      --media-font-size: 13px;

      @include media-query(sm) {
        padding: 10px 26px;
      }
    }

    // Dropdown menu
    &::part(listbox) {
      max-height: 140px;
      border-radius: 4px;

      @include media-query(sm) {
        max-height: unset;
      }
    }

    // Single dropdown option
    &::part(option) {
      border-radius: 4px;
      min-height: 32px;
    }
  }
`
